interface Props {
  eyebrow?: string
  title: string
  subtitle?: string
  align?: 'left' | 'center'
}

export default function SectionHeader({ eyebrow, title, subtitle, align = 'center' }: Props) {
  return (
    <div className={`max-w-3xl ${align === 'center' ? 'mx-auto text-center' : ''}`}>
      {eyebrow && (
        <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full bg-urgent-50 text-urgent-600 text-xs font-bold uppercase tracking-wider mb-4`}>
          <span className="w-1.5 h-1.5 rounded-full bg-urgent-500" />
          {eyebrow}
        </div>
      )}
      <h2 className="text-3xl lg:text-5xl font-extrabold text-navy-700 tracking-tight text-balance">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-4 text-base lg:text-lg text-navy-500 leading-relaxed text-balance">
          {subtitle}
        </p>
      )}
    </div>
  )
}
